/**
 * AuthGuard Component (TASK-088)
 *
 * Protects dashboard routes: KAN-925 lets in when the tab has an active
 * signed-in account (lib/accounts; old authToken is migrated there).
 * Redirects to /login if unauthenticated, saving the requested URL
 * so the user can be redirected back after login.
 */
import { Navigate, useLocation } from 'react-router-dom'
import { getActiveAccessToken } from '@/lib/accounts'
import { REDIRECT_AFTER_LOGIN_KEY } from '@/lib/afterLogin'
import { isMobileAppPath, MOBILE_LOGIN_PATH } from '@/lib/mobileApp'

interface AuthGuardProps {
  children: React.ReactNode
}

export function AuthGuard({ children }: AuthGuardProps) {
  const location = useLocation()
  const token = getActiveAccessToken()

  if (!token || token.trim() === '') {
    // KAN-846: приложение менеджера входит на своей форме (логин и пароль; там же
    // подсказка про ссылку), а не на /login кабинета
    if (isMobileAppPath(location.pathname)) {
      return <Navigate to={MOBILE_LOGIN_PATH} replace />
    }
    // Save the requested URL for redirect after login. KAN-881: вместе с
    // параметрами, иначе ?desktop=1 ("Полная CRM" из приложения) терялся
    localStorage.setItem(REDIRECT_AFTER_LOGIN_KEY, `${location.pathname}${location.search}`)
    return <Navigate to="/login" replace />
  }

  return <>{children}</>
}
